import home_illustra from "./home/home-illustra.svg";
import mobile_illustra from "./home/mobileHome.svg";
import tab_illustra from "./home/tab-illustra.svg";
import github from "./home/icons8-github.svg";
import linkedin from "./home/icons8-linkedin.svg";
import twitter from "./home/icons8-twitter.svg";
import logo from "./home/logo.svg";
import menu from "./home/menue.svg";
import themestar from "./home/themestar.svg";
import blob from "./blob.svg";
import bookShelf from "./bookshelf.svg";
import bookimg from "./littlelife.jpg";
import preview from "./preview.svg";

export const home_illustrations = {
  home_illustra,
  tab_illustra,
  mobile_illustra,
  logo,
  blob,
  menu,
  preview,
  themestar,
  github,
  twitter,
  linkedin,
  bookShelf,
  bookimg,
};
